import { Component, Inject } from "@angular/core";
import { EditBase } from "../../../settings/shared/edit.base";
import { ServiceConfig } from "../../../core/core.constants";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { PersonDataService } from "../../../core/persons.dataservice";
import { AppSettingsService } from "../../../core/appsettings";
import * as dataCore from "../../../core/datacore";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
    selector: "crew-person-edit",
    template: require('./person.edit.component.html')
})
export class EditPersonDetailsComponent extends EditBase<Nema.Crew.Model.Person> {

    public DateOfBirth: Date;
    public SyncNokFromHr: Observable<boolean>;

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('person') personEntity: Nema.Crew.Model.Person,
        @Inject(PersonDataService.Id) personDataService: PersonDataService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean,
        settings: AppSettingsService) {

        super(stateService, transitionService, dialog, personEntity, personDataService, $log, isNew);

        this.DateOfBirth = dataCore.addTimezoneOffset(this.entity.DateOfBirth);

        this.SyncNokFromHr = settings.getAppSetting("SyncNokFromHr").pipe(map(res => res.body));
    }

    public save(): Promise<void> {
        this.entity.DateOfBirth = dataCore.subtractTimezoneOffset(this.DateOfBirth);
        return super.save();
    }
    
    webApiUrl: string = ServiceConfig.webApiUrl;

    public entityDisplayName = "Person";

    public listStateName = "app.resources.persons";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/details/person.edit.component.ts